import { render, staticRenderFns } from "./DetalhesAtracoesArtisticas.vue?vue&type=template&id=00508e19&scoped=true"
import script from "./DetalhesAtracoesArtisticas.vue?vue&type=script&lang=ts"
export * from "./DetalhesAtracoesArtisticas.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesAtracoesArtisticas.vue?vue&type=style&index=0&id=00508e19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00508e19",
  null
  
)

export default component.exports